import { WebApiReduxRequest } from "tools/webservice";
import { REQUEST_CASE_STEPPER, RECEIVE_CASE_STEPPER, ERROR_CASE_STEPPER } from 'typeConstants';

export const getCaseStatusTracker = (controlNumber) => WebApiReduxRequest(
  REQUEST_CASE_STEPPER,
  RECEIVE_CASE_STEPPER,
  ERROR_CASE_STEPPER,
  "GET",
  `/case-status/${controlNumber}/status-tracker`,
);